import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgScrollbarModule, provideScrollbarOptions } from "ngx-scrollbar";

import { CoreDirectivesModule } from "@core/directives/directives";
import { CoreSidebarModule } from "@core/components/core-sidebar/core-sidebar.module";

import { CoreThemeCustomizerComponent } from "@core/components/theme-customizer/theme-customizer.component";

@NgModule({
  declarations: [CoreThemeCustomizerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgScrollbarModule,
    CoreDirectivesModule,
    CoreSidebarModule,
  ],
  exports: [CoreThemeCustomizerComponent],
  providers: [
    provideScrollbarOptions({
      visibility: "hover",
      appearance: "compact",
    }),
  ],
})
export class CoreThemeCustomizerModule {}
